import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import Link from 'next/link';
import Image from 'next/image';

const useStyles = makeStyles(theme => ({
  root: {
    margin: theme.spacing(2, 0),
    listStyle: 'none',
    padding: 0,
    '& [data-ui=thumbnails]': {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start'
    }
  },
  thumbnail: {
    marginBottom: '10px',
    display: 'none',
    '[data-ui=thumbnails] &': {
      display: 'block',
      '& img': {
        height: 120,
        width: 120,
        minWidth: 120
      }
    }
  },
  text: {},
  highlight: {
    backgroundColor: 'rgba(0,0,0,0.05)',
    borderRadius: '2px',
    color: theme.palette.secondary.main
  }
}));

function SearchSuggestionItem({ ImageComponent = Image, classes, item, ui, thumbnailProps, children }) {
  const styles = useStyles();
  return (
    <li className={styles.root}>
      <Link as={item.as} href={item.href}>
        {children ? children : (
            <div data-ui={ui}>
              {item.thumbnail && <ImageComponent alt={item?.text} width={120} height={120} className={styles.thumbnail} {...thumbnailProps} {...item.thumbnail} />}
             <p title={item.text}> {item.text}</p>
            </div>
        )}
      </Link>
    </li>
  );
}

SearchSuggestionItem.propTypes = {
  classes: PropTypes.object,
  children: PropTypes.node,
  item: PropTypes.shape({
    as: PropTypes.string,
    href: PropTypes.string,
    text: PropTypes.string,
    pageData: PropTypes.object,
    thumbnail: PropTypes.object
  }),
  thumbnailProps: PropTypes.object,
  ImageComponent: PropTypes.elementType
};

export default SearchSuggestionItem;